import { Injectable } from '@angular/core';
import { BaseRepository } from './base.repository';
import { IDQGateQuarantineModel } from '../entities-api/IDQGateQuarantineModel';
import { IDQGateDetailModel } from '../entities-api/IDQGateDetailModel';
import { IDQGateAuditLogModel } from '../entities-api/IDQGateAuditLogModel';
import { IDQGateSnapshotModel } from '../entities-api/IDQGateSnapshotModel';
import { IDQGateRejectResult } from '../entities-api/IDQGateRejectResult';

@Injectable()
export class DqGateRepository extends BaseRepository {

    getPending(): Promise<IDQGateQuarantineModel[]> {
        return this.get<IDQGateQuarantineModel[]>('api/DQGate/GetPending');
    }

    getStatus(quarantineId: string): Promise<IDQGateQuarantineModel> {
        return this.get<IDQGateQuarantineModel>(`api/DQGate/GetStatus/${quarantineId}`);
    }

    getDetail(quarantineId: string): Promise<IDQGateDetailModel[]> {
        return this.get<IDQGateDetailModel[]>(`api/DQGate/GetDetail/${quarantineId}`);
    }

    getSnapshot(quarantineId: string): Promise<IDQGateSnapshotModel[]> {
        return this.get<IDQGateSnapshotModel[]>(`api/DQGate/GetSnapshot/${quarantineId}`);
    }

    getAuditLog(runId: string): Promise<IDQGateAuditLogModel[]> {
        return this.get<IDQGateAuditLogModel[]>(`api/DQGate/GetAuditLog/${runId}`);
    }

    approve(quarantineId: string, snapshotIds: string[]): Promise<any> {
        return this.post<any>({ Url: `api/DQGate/Approve/${quarantineId}`, Body: { SnapshotIds: snapshotIds } });
    }

    reject(quarantineId: string, snapshotIds: string[], comments?: string): Promise<IDQGateRejectResult> {
        return this.post<IDQGateRejectResult>({
            Url: `api/DQGate/Reject/${quarantineId}`,
            Body: { SnapshotIds: snapshotIds, Comments: comments || null }
        });
    }

    retry(quarantineId: string): Promise<void> {
        return this.post<void>({ Url: `api/DQGate/Retry/${quarantineId}`, Body: null });
    }
}
